<script>
  export let value;
  export let lang = undefined;
</script>

<div class='contact'>
  <div class='contact-box'>
    <div class='contact-box-content'>
      <div class='contact-box-content-name'>
        {value.firstName} {value.lastName}
      </div>

      <div class='contact-box-content-position-email-and-phone'>
        <div class='contact-box-content-position-email-and-phone-position'>
          {value.position[lang]}
        </div>

        {#if value.email}
          <a href='mailto:{value.email}' class='contact-box-content-position-email-and-phone-email'>
            {value.email}
          </a>
        {/if}

        {#if value.phone}
          <a href='tel:{value.phone}' class='contact-box-content-position-email-and-phone-phone'>
            {value.phone}
          </a>
        {/if}
      </div>
    </div>

    {#if value.photo}
      <img class='contact-box-image' src='img/contact/{value.code}.jpg' alt='{value.firstName} {value.lastName} photo'/>
    {:else}
      <div class='contact-box-image-blank'/>
    {/if}
  </div>
</div>

<style>
  .contact {
    flex-grow: 1;

    width: 100%;
  }

  .contact-box {
    position: relative;

    display: flex;

    height: 100%;

    border-radius: 5px;

    background: var(--grey-3);
  }

  .contact-box-content {
    display: flex;
    flex-direction: column;
    gap: 5px;

    padding: 15px;

    width: calc(100% - 110px);
  }

  .contact-box-content-name {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 25px;

    font-family: var(--font-secondary);
    font-size: 20px;
  }

  .contact-box-content-position-email-and-phone {
    display: flex;
    flex-direction: column;
    justify-content: center;

    height: 100%;

    font-size: 14px;
  }

  .contact-box-content-position-email-and-phone-position {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 20px;

    font-weight: 550;

    color: var(--tertiary);
  }

  .contact-box-content-position-email-and-phone-email {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 20px;

    text-decoration: underline;
    text-decoration-thickness: 1.25px;
    text-decoration-color: transparent;

    color: var(--grey-7);

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .contact-box-content-position-email-and-phone-email:hover {
    text-decoration-color: var(--grey-7);
  }

  .contact-box-content-position-email-and-phone-phone {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 20px;

    text-decoration: underline;
    text-decoration-thickness: 1.25px;
    text-decoration-color: transparent;

    color: var(--grey-7);

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .contact-box-content-position-email-and-phone-phone:hover {
    text-decoration-color: var(--grey-7);
  }

  .contact-box-image {
    position: absolute;
    right: 0px;

    width: 80px;
    height: 100%;

    border-radius: 0px 5px 5px 0px;

    object-fit: cover;
    object-position: top;
  }

  .contact-box-image-blank {
    position: absolute;
    right: 0px;

    width: 80px;
    height: 100%;

    border-radius: 0px 5px 5px 0px;

    background: var(--grey-4);
  }

  :global(body.dark) .contact-box {
    background: var(--grey-7);
    color: var(--black);
  }

  :global(body.dark) .contact-box-content-position-email-and-phone-email {
    color: var(--grey-5);
  }

  :global(body.dark) .contact-box-content-position-email-and-phone-email:hover {
    text-decoration-color: var(--grey-5);
  }

  :global(body.dark) .contact-box-content-position-email-and-phone-phone {
    color: var(--grey-5);
  }

  :global(body.dark) .contact-box-content-position-email-and-phone-phone:hover {
    text-decoration-color: var(--grey-5);
  }

  :global(body.dark) .contact-box-image {
    filter: brightness(88%);
  }

  :global(body.dark) .contact-box-image-blank {
    background: var(--grey-5);
  }

  @media only screen and (max-width: 1300px) {
    .contact {
      width: calc((100% - 40px) / 3);
    }
  }

  @media only screen and (max-width: 1200px) {
    .contact {
      width: calc((100% - 20px) / 2);
    }
  }

  @media only screen and (max-width: 850px) {
    .contact {
      width: 100%;
    }
  }

  @media only screen and (max-width: 500px) {
    .contact-box-content {
      width: 100%;
    }

    .contact-box-image {
      display: none;
    }

    .contact-box-image-blank {
      display: none;
    }
  }
</style>
